import { render, staticRenderFns } from "./JobfairCreationTypeSelect.vue?vue&type=template&id=6967d5ce&scoped=true"
import script from "./JobfairCreationTypeSelect.vue?vue&type=script&lang=js"
export * from "./JobfairCreationTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./JobfairCreationTypeSelect.vue?vue&type=style&index=0&id=6967d5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6967d5ce",
  null
  
)

export default component.exports